export enum MapBoxProvideInstanceEnum {
	MAP = 'mapbox-instance',
	DRAW = 'mapbox-draw-instance',
}
